module.exports = __webpack_public_path__ + "img/dry-hairy-tree-01.98cb6c4d.png";